<script lang="ts">
    import {createEventDispatcher} from "svelte";

    export let label: string;
	export let style: string = '';
	export let cls: string = '';

    const dispatch = createEventDispatcher<{
		delete: null
    }>();
</script>

<div class="chip-item {cls}" {style}>
    <slot name="start"></slot>
    <span class="chip-label">{label}</span>
    <img class="clear-icon" alt="remove filter" on:click={() => dispatch('delete')} src="./map/img/clear_white.png">
</div>

<style>
    .chip-item {
        display: flex;
        background: #FE6D50;
        padding: 0.5rem;
        color: white;
    }
    .clear-icon {
        cursor: pointer;
        margin: auto 0 auto 0.5rem !important;
    }
    .chip-label {
        white-space: nowrap;
    }
</style>
